import React, { type ReactNode } from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { PriorityChipField as PriorityChipFieldType } from './main.tsx';

type PriorityChipFieldBoundaryProps = {
	children: ReactNode;
	fallback: ReactNode;
	packageName: string;
};

export const PriorityChipFieldBoundary = ({
	children,
	fallback,
	packageName,
}: PriorityChipFieldBoundaryProps) => (
	<ErrorBoundary id="issue-priority-chip" packageName={packageName} render={() => fallback}>
		<Placeholder name="issue-priority-chip-boundary" fallback={fallback}>
			{children}
		</Placeholder>
	</ErrorBoundary>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncLazyPriorityChipField = lazy<typeof PriorityChipFieldType>(() =>
	import(/* webpackChunkName: "async-issue-field-priority" */ './main').then(
		({ PriorityChipField }) => PriorityChipField,
	),
);
